import React, { useState } from "react";
import sha256 from "js-sha256";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { emailValidation, convertTextToLowerCase } from "../services/functions";
import AuthService from "../services/authService";
import Sidebar from "./Sidebar";

export default function Header() {
  const { email } = useParams();
  const navigate = useNavigate();

  const apiCustomerUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/customer`;

  const [searchText, setSearchText] = useState("");
  const [buttonText, setButtonText] = useState("Search");
  const [showSpinner, setShowSpinner] = useState("visually-hidden");
  const [validEmailError, setvalidEmailError] = useState("");

  const accessToken = localStorage.getItem("accessToken");
  const loggedInName = localStorage.getItem("loggedInName");

  const handleLogout = (e) => {
    e.preventDefault();
    AuthService.logout();
    navigate("/login");
  };

  const handleSearchOnChange = (event) => {
    setvalidEmailError("");
    let emailVal = convertTextToLowerCase(event.target.value);
    setSearchText(emailVal);
  };

  const handleSearchClick = (event) => {
    event.preventDefault();

    if (emailValidation(searchText)) {
      setButtonText("Searching");
      setShowSpinner("");
      setvalidEmailError("");
      const hash = sha256(searchText);
      let customerUrl = `${apiCustomerUrl}?hash=${hash}`;
      GetCustomerStatus(customerUrl);
    } else {
      setvalidEmailError("Please Enter Valid Email");
    }
  };

  // Customer Data
  const GetCustomerStatus = (URl) => {
    axios
      .get(URl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((result) => {
        setShowSpinner("visually-hidden");
        setButtonText("Search");
        setTimeout(() => {
          navigate(`/customers/${searchText}`);
        }, 1000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  return (
    <>
      <header className="app-header fixed-top">
        <div className="app-header-inner">
          <div className="container-fluid py-2">
            <div className="app-header-content">
              <div className="row justify-content-between align-items-center">
                <div className="col-7 form-outline">
                  <form className="d-flex text-center" role="search">
                    <input
                      type="email"
                      placeholder="Search Email..."
                      name="searchterm"
                      className="form-control border rounded-pill"
                      value={searchText}
                      onChange={handleSearchOnChange}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    />
                    &nbsp;&nbsp;
                    <button
                      type="submit"
                      className="btn search-btn btn-primary col-2 align-middle me-1"
                      value="Search"
                      onClick={handleSearchClick}
                    >
                      <span
                        className={`spinner-grow spinner-grow-sm me-1 ${showSpinner}`}
                      ></span>
                      <span className="">{buttonText}</span>
                    </button>
                    <small className="form-text mt-2 w-25 text-danger">
                      {validEmailError}
                    </small>
                  </form>
                </div>
                <div className="app-utilities col-auto">
                  <div className="app-utility-item">
                    Logged in :{" "}
                    <span className="badge bg-primary text-wrap">
                      {loggedInName}
                    </span>{" "}
                    &nbsp;
                    <a
                      className="fw-bold"
                      id="notifications-dropdown-toggle"
                      href="/"
                      role="button"
                      aria-expanded="false"
                      title="Logout"
                      onClick={handleLogout}
                    >
                      (Logout)
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Sidebar searchterm={email} />
      </header>
    </>
  );
}
